require('./brokerHireAlternativeInvestmentFundIntro.scss');
// @ vendors
const PropTypes = require('prop-types');
// @ commons
const { ContentBox } = require('commonsComponents/contentBox');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { taggingEventHandled } = require('../../../../utilities/taggingEventHandled');
const { FormattedText } = require('core/i18n').i18n;
//@ constants
const {
    PROC_BROKER_HIRE_ALTERNATIVE_FUNDS_PG_NAME
} = require('utilities/tagging');

//@ utilities
const { recordPage } = require('utilities/tagging.js')

class BrokerHireAlternativeInvestmentFundIntro extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      startedVideo: false,
    };
    this.onClickPlay = this.onClickPlay.bind(this);
    this.handleOnClickStart = this.handleOnClickStart.bind(this);
  }

  componentWillMount () {
    const fundName = this.props.fund.get('name')
    const customData = {
      nombrePagina: `caracteristicas fondo alternativo/${fundName}`,
    };
    recordPage(customData)
  }

  onClickPlay() {
    this.setState({ startedVideo: true });
  }
  
  handleOnClickStart = () => {
    const fundName = this.props.fund.get('name')
    this.props.onClickStart();
    taggingEventHandled(PROC_BROKER_HIRE_ALTERNATIVE_FUNDS_PG_NAME, 'startButton', fundName );
  }
  render() {
    const { onClickCancel } = this.props;

    return (
      <section className="broker-hire-alteranitve-fund-intro">
        <ContentBox id="brokerStocksLikeHeader" customClassName="content-box">
          <section className="characteristics">
            <div className="container-title">
              <FormattedText value="brokerAlternativeFundsBuy-title" className="title-text"/>
            </div>
              <FormattedText value="brokerAlternativeFundsBuy-description" className="description-text"/>
            <div className="video-container">
              {!this.state.startedVideo ? (
                <div className="cover-container">
                  <div className="cover-img"></div>
                  <div
                    onClick={this.onClickPlay}
                    className="cover-container__playButton"
                    tabindex="9"
                  >
                    <div className="cover-container__playButtonCircle">
                      <svg
                        width="24px"
                        height="24px"
                        viewBox="0 0 32 32"
                        aria-hidden="true"
                        data-id="Play"
                      >
                        <path
                          d="M28.1542369,14.3950429 L11.2393158,2.38145067 C10.6185599,1.94179981 9.79449964,1.87558733 9.11410778,2.21724372 C8.42829448,2.55625161 8,3.2448614 8,3.98908966 L8,28.0083286 C8,28.7605024 8.42829448,29.4464637 9.11410778,29.7854716 C9.4041553,29.9284905 9.72131007,30 10.0411756,30 C10.4586271,30 10.8815002,29.8702235 11.2393158,29.6133191 L28.1542369,17.6103209 C28.6882496,17.2262885 29,16.6330247 29,16.0026819 C29.0026936,15.3617451 28.6828281,14.7711298 28.1542369,14.3950429 Z"
                          fill="#ffffff"
                        ></path>
                      </svg>
                    </div>
                  </div>
                </div>
              ) : (
                <iframe
                  src="https://www.youtube.com/embed/Xui0rf5fBVg?modestbranding=1&rel=0&iv_load_policy=3&hl=es-sp&fs=0&color=white&controls=0&disablekb=1&autoplay=1"
                  width="1110"
                  height="624"
                  title="Invierte en fondos alternativos con Openbank"
                  frameborder="0"
                  allow="autoplay;"
                ></iframe>
              )}
            </div>
          </section>
          <section className="steps-to-hire">
            <div className="container-title">
              <FormattedText value="brokerAlternativeFundsBuy-steps_title" className="title-text"/>
            </div>
            <div className="steps-container">
              <div className="step">
                <div className= "step1-img" />
                <FormattedText value="brokerAlternativeFundsBuy-step1_title" className="title-text" />
                <FormattedText value="brokerAlternativeFundsBuy-step1_description" className="description-text"/>
              </div>
              <div className="step">
              <div className= "step2-img" />
                <FormattedText value="brokerAlternativeFundsBuy-step2_title" className="title-text" />
                <FormattedText value="brokerAlternativeFundsBuy-step2_description" className="description-text"/>
                <div className="content"></div>
              </div>
              <div className="step">
                <div className= "step3-img" />
                <FormattedText value="brokerAlternativeFundsBuy-step3_title" className="title-text" />
                <FormattedText value="brokerAlternativeFundsBuy-step3_description" className="description-text"/>
                <div className="content"></div>
              </div>
              <div className="step">
                <div className= "step4-img" />
                <FormattedText value="brokerAlternativeFundsBuy-step4_title" className="title-text" />
                <FormattedText value="brokerAlternativeFundsBuy-step4_description" className="description-text"/>
                <div className="content"></div>
              </div>
            </div>
          </section>
          <section className="buttons-container">
            <OKButton
              modifier="link-ghost"
              onClick={onClickCancel}
              disabled={""}
            >
              <FormattedText value="brokerAlternativeFundsBuy-cancel" />
            </OKButton>
            <OKButton onClick={this.handleOnClickStart}>
              <FormattedText value="brokerAlternativeFundsBuy-start" />
            </OKButton>
          </section>
        </ContentBox>
      </section>
    );
  }
}

BrokerHireAlternativeInvestmentFundIntro.propTypes = {
  fund: PropTypes.object.isRequired,
  onClickStart: PropTypes.func.isRequired,
  onClickCancel: PropTypes.func.isRequired,
};

module.exports = BrokerHireAlternativeInvestmentFundIntro;
